import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";
import GlobalStyle from "./style/globalStyle";
import Header from "./components/Header";
import Gnb from "./components/Gnb";
import { Alert } from "./components/common/Alert";
import { Spinner } from "./components/common/Spinner";

function App() {
  const location = useLocation();
  const [isLogin, setIsLogin] = useState(false);
  const [isLoding, setIsLoding] = useState(false);

  useEffect(() => {
    setIsLogin(location.pathname === "/" || location.pathname === "/login");
  }, [location]);

  useEffect(() => {
    setIsLoding(true);
  }, []);
  
  return (
    <div>
      {isLoding ? (
        <>
          <GlobalStyle />
          <OutletLayout $isLogin={isLogin}>
            {!isLogin && <Gnb />}
            <OutletBody>
              {!isLogin && <Header />}
              <Outlet />
            </OutletBody>
          </OutletLayout>
          <Alert />
        </>
      ) : <Spinner />}
    </div>
  );
}

export default App;

const OutletLayout = styled.div<{ $isLogin: boolean; }>`
  min-height: 100vh;
  height: max-content;
  display: grid;
  grid-template-columns: ${({ $isLogin }) => $isLogin ? "1fr" : "300px calc(100% - 300px)"};
`;

const OutletBody = styled.div`
  background-color: #F7F7F7;
  min-height: 100vh;
  height: max-content;
`;
